import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getTalents } from '@libs/api/talents';
import { DateRangeShortcutsItem } from '@libs/models/common';
import { dateRangeShortcuts } from '@libs/models/common';
import { createDefaultFilterSlice, DefaultFilterState } from '../../filters';
import { StaffListItem } from '@libs/models/talents/talent';

type ShiftFilterState = {
  dateRangeShortcuts: DateRangeShortcutsItem[];
  loading: boolean;
  filterProviders: StaffListItem[];
  loadData: (options: { locationId: string }) => Promise<void>;
};
export const useCalendarFilters = create<DefaultFilterState & ShiftFilterState>()(
  persist(
    (set, get, store) => ({
      ...createDefaultFilterSlice(set, get, store),
      dateRangeShortcuts: dateRangeShortcuts,
      loading: false,
      filterProviders: [],

      loadData: async ({ locationId }) => {
        set({
          loading: true,
        });

        try {
          const { items: talents } = await getTalents({
            filters: {
              statuses: {
                key: 'statuses',
                value: ['Active'],
              },
              locations: {
                key: 'locations',
                value: [locationId],
              },
            },
            page: -1,
            size: 0,
          });
          set({
            filterProviders: talents,
            loading: false,
          });
        } catch (error) {
          set({
            loading: false,
          });
          throw error;
        }
      },
    }),
    {
      name: 'userdata:calendarFilters',
      partialize: (state) =>
        Object.keys(state)
          .filter((key) => !['dateRangeShortcuts', 'loading', 'filterProviders'].includes(key))
          .reduce((acc, key) => ({ ...acc, [key]: (state as any)[key] }), {}),
    },
  ),
);
